(() => {
  if (window.soneeCollectionSwitcherLoaded) return;
  window.soneeCollectionSwitcherLoaded = true;
  function init(root) {
    root.querySelectorAll('[data-sonee-collection-switcher]').forEach(section => {
      if (section.classList.contains('sonee-collection-switcher--ready')) return;
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const panels = [...section.querySelectorAll('[role="tabpanel"]')];
      if (!tabs.length) return;
      function select(tab) {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        window.dispatchEvent(new Event('resize'));
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); select(tabs[next]); tabs[next].focus();
        });
      });
      section.classList.add('sonee-collection-switcher--ready');
      select(tabs[0]);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
